module.exports = __webpack_public_path__ + "media/images/flags/ie-0202015eb5d6a3f9a2025422cc903547.svg";